import { useEffect } from "react";

import { useIsValidSidekickClientEmbedOrigin } from "./useIsValidSidekickClientEmbedOrigin";

export const useMountedMessage = () => {
  const isValidOrigin = useIsValidSidekickClientEmbedOrigin();

  useEffect(() => {
    if (isValidOrigin) {
      window.parent.postMessage(
        {
          type: "mb.mounted",
        },
        window.parent.origin,
      );
    }
  }, [isValidOrigin]);
};
